import type { VoidFunctionComponent } from 'react';

import Select from '../../generic/Select/Select';
import type { AnyFilter } from '../../../../shared/organizationPackages';
import { selectOptionFactory } from '../../../utils';

type Props = {
  isLoading: boolean;
  packageLabelOptions: string[];
  selectedPackageLabels: string[];
  setFilters: (...args: AnyFilter[]) => void;
};

/**
 * Displays a multi-select dropdown for filtering packages by package labels.
 */
const PackageLabelsFilter: VoidFunctionComponent<Props> = ({
  isLoading,
  packageLabelOptions,
  selectedPackageLabels,
  setFilters,
}) => {
  const isDisabled = isLoading || packageLabelOptions.length === 0;
  return (
    <Select
      isMulti
      isClearable
      id="package-index-package-labels-filter"
      placeholder={isLoading ? 'Loading...' : 'Package labels'}
      value={selectedPackageLabels.map((label) => selectOptionFactory(label))}
      options={packageLabelOptions.map((label) => selectOptionFactory(label))}
      isDisabled={isDisabled}
      onChange={(labels) => {
        setFilters({ packageLabels: (labels).map(({ value }) => value) });
      }}
    />
  );
};

export default PackageLabelsFilter;
